import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderAR from "../../headerAR/headerar";
import FooterAR from "../../footerAR/footerar";
import './arerpbasedsolutions.scss';

const ARErpBasedSolutions = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div class="main-fluid">
      <HeaderAR />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div class="dsk-tab-btn-viewmode-ar">
        <div class="erpbasedsolu-tab-imagebannermain-ar">
          <div class="erpbasedsolu-banner-con-ar">
            <div class="erpbasedsolutab-banne-sec-ar">
              <h1 class="erpbasedsolu-banner-heading-ar">خدمات استشارات للمطالبة</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="erpbasedsolu-tab-btn-ar">
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "report-a-claim-ar"}>الإبلاغ عن مطالبة </div>
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "claim-consultancy-services-ar"}>خدمات استشارات المطالبات </div>
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "service-excellence-ar"}>التميز في الخدمة </div>
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "in-house-kr-automotive-garage-ar"}>مرأب سيارات شركة كيمجي رامداس الداخلية</div>
                <div class="erpbasedsolu-tab-btn-item-active-ar" onClick={() => window.location.href = "erp-based-solutions-ar"}>الحلول القائمة على تخطيط موارد المؤسسة</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="erpbasedsolu-banner-con-ar">
          <div class="erpbasedsolu-bdy-ar">
            <div class="erpbasedsolu-dflex-ar">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div class="erpbasedsolu-dlex-rgt-ar">
                <img src={process.env.PUBLIC_URL + "/customer_service/tab_images/erp_based_solution_ar.png"} alt="الحلول القائمة على تخطيط موارد المؤسسة " />
              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div class="erpbasedsolu-dlex-lft-ar">
                <h2 class="pagetitle-ar">الحلول القائمة على تخطيط موارد المؤسسة </h2>

                <p class="erpbasedsolu-pg-txt-con-ar">تعمل شركة كيمجي رامداس لخدمات التأمين على برنامج تخطيط موارد المؤسسة لتسه أفضل التأمينات الصناعية، ويتم ذلك من خلال</p>

                <div class="erpbasedsolu-keypoint-ar">
                  <div class="erpbasedsolu-keypoint-item-ar">خدمات خالية من المتاعب للعملاء</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">الوثائق الرقمية (استمارات المطالبات ونماذج الاقتراحات وصور بوليصة التأمين وما إلى ذلك)</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">الحفاظ على سرية البيانات</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">الشهادات والتصديقات البحرية والسياسية</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">فحوصات الجودة - الشروط المقترحة مقابل شروط الوثيقة المستلمة</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">تنبيه بالمطالبات وعملية التسوية وتحديثات حالة المطالبة</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">توفير تذكير التجديد التلقائي</div>

                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-ar">إعداد التقارير إلكترونيًا</div>
                  <div class="erpbasedsolu-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                </div>

              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>
                
                <h3 class="erpbasedsolu-whykrinsu-title-ar">ما الذي يُميز شركة كيمجي رامداس لخدمات التأمين عن غيرها؟ </h3>
                <div class="clearfix"></div>
                
                <div class="erpbasedsolu-pins-list-lftdksp-ar">
                  <div class="erpbasedsolu-lt-two-lftdksp-ar">خدمات المطالبات الفورية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                  <div class="erpbasedsolu-lt-one-lftdksp-ar">شروط تنافسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                  <div class="erpbasedsolu-lt-two-lftdksp-ar">أفضل ممارسات صناعة التأمين <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                  <div class="erpbasedsolu-lt-one-lftdksp-ar">مقارنات عروض أسعار واسعة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                </div>
          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* TAB-VIEW AND TABS SECTION STARTS HERE */}
      <div className="tab-btn-viewmode-ar">
        <div class="erpbasedsolu-tab-imagebannermain-ar">
          <div class="erpbasedsolu-banner-con-ar">
            <div class="erpbasedsolutab-banne-sec-ar">
              <h1 class="erpbasedsolu-banner-heading-ar">خدمات استشارات للمطالبة</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="erpbasedsolu-tab-btn-ar">
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "report-a-claim-ar"}>الإبلاغ عن مطالبة </div>
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "claim-consultancy-services-ar"}>خدمات استشارات المطالبات </div>
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "service-excellence-ar"}>التميز في الخدمة </div>
                <div class="erpbasedsolu-tab-btn-item-ar" onClick={() => window.location.href = "in-house-kr-automotive-garage-ar"}>مرأب سيارات شركة كيمجي رامداس الداخلية</div>
                <div class="erpbasedsolu-tab-btn-item-active-ar" onClick={() => window.location.href = "erp-based-solutions-ar"}>الحلول القائمة على تخطيط موارد المؤسسة</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="erpbasedsolu-banner-con-ar">
          <div className="tab-imgtxt-ar">
            <h2>الحلول القائمة على تخطيط موارد المؤسسة </h2>
            <div className="tabs-cont-ar">
              <img className="rgt-img-ar" src={process.env.PUBLIC_URL + "/customer_service/tab_images/erp_based_solution_ar.png"} alt="الحلول القائمة على تخطيط موارد المؤسسة " />
              <p>تعمل شركة كيمجي رامداس لخدمات التأمين على برنامج تخطيط موارد المؤسسة لتسهيل أفضل التأمينات الصناعية، ويتم ذلك من خلال</p>

              <p className="tabimg-list">خدمات خالية من المتاعب للعملاء<img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list">الوثائق الرقمية (استمارات المطالبات ونماذج الاقتراحات وصور بوليصة التأمين وما إلى ذلك) <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list">الحفاظ على سرية البيانات <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list">الشهادات والتصديقات البحرية والسياسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list">فحوصات الجودة - الشروط المقترحة مقابل شروط الوثيقة المستلمة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list-wdth">تنبيه بالمطالبات وعملية التسوية وتحديثات حالة المطالبة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list-wdth">توفير تذكير التجديد التلقائي <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              <p className="tabimg-list-wdth">إعداد التقارير إلكترونيًا <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </p>
              
              <h3 class="tab-whykrinsu-title-ar">ما الذي يُميز شركة كيمجي رامداس لخدمات التأمين عن غيرها؟ </h3>
              
              <div class="tab-whykrinsu-pins-list-ar">
                <div class="tab-whykrinsu-pinlft-two-ar">خدمات المطالبات الفورية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                <div class="tab-whykrinsu-pinlft-one-ar">شروط تنافسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                <div class="tab-whykrinsu-pinlft-two-ar">أفضل ممارسات صناعة التأمين <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
                <div class="tab-whykrinsu-pinlft-one-ar">مقارنات عروض أسعار واسعة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            </div>

            </div>
          </div>

        </div>
      </div>
      {/* TAB-VIEW AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="erpbasedsolu-tab-imagebannermain-ar hidden-desktop hidden-md-device hidden-lg">
        <div class="dropdown-sec">
          <select class="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"report-a-claim-ar"}>الإبلاغ عن مطالبة </option>
            <option value={"claim-consultancy-services-ar"}>خدمات استشارات المطالبات</option>
            <option value={"service-excellence-ar"}>التميز في الخدمة </option>
            <option value={"in-house-kr-automotive-garage-ar"}>مرأب سيارات شركة كيمجي رامداس الداخلية</option>
            <option value={"erp-based-solutions-ar"} selected class="active">الحلول القائمة على تخطيط موارد المؤسسة</option>
          </select>
        </div>
        <div class="erpbasedsolu-mob-main-ar">
          <h1 class="erpbasedsolu-banner-heading-ar">الحلول القائمة على تخطيط موارد المؤسسة </h1>
          <div class="erpbasedsolu-mob-img-ar">
            <img src={process.env.PUBLIC_URL + "/customer_service/tab_images/erp_based_solution_ar.png"} alt="الحلول القائمة على تخطيط موارد المؤسسة " />
          </div>

          <p class="erpbasedsolu-mob-txt-ar">تعمل شركة كيمجي رامداس لخدمات التأمين على برنامج تخطيط موارد المؤسسة لتسهيل أفضل التأمينات الصناعية، ويتم ذلك من خلال</p>

          <div class="erpbasedsolu-pins-list-mob-ar">
            <div class="erpbasedsolu-pins-list-mob-item-ar">خدمات خالية من المتاعب للعملاء</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">الوثائق الرقمية (استمارات المطالبات ونماذج الاقتراحات وصور بوليصة التأمين وما إلى ذلك)</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">الحفاظ على سرية البيانات </div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">الشهادات والتصديقات البحرية والسياسية </div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">فحوصات الجودة - الشروط المقترحة مقابل شروط الوثيقة المستلمة</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">تنبيه بالمطالبات وعملية التسوية وتحديثات حالة المطالبة</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">توفير تذكير التجديد التلقائي</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-ar">إعداد التقارير إلكترونيًا</div>
            <div class="erpbasedsolu-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
          </div>
          
          <h3 class="erpbasedsolu-whykrinsu-mob-title-ar">ما الذي يُميز شركة كيمجي رامداس لخدمات التأمين عن غيرها؟ </h3>

          <div class="erpbasedsolu-mob-whykrlist-ar">
            <div class="erpbasedsolu-mob-whykrlist-item-ar">شروط تنافسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            <div class="erpbasedsolu-mob-whykrlist-item-ar">خدمات المطالبات الفورية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            <div class="erpbasedsolu-mob-whykrlist-item-ar">مقارنات عروض أسعار واسعة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            <div class="erpbasedsolu-mob-whykrlist-item-ar">أفضل ممارسات صناعة التأمين <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
          </div>

        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterAR />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default ARErpBasedSolutions;
